import { createContext, useContext, useState } from "react";
import type { AnyBoomerFormApi } from "@/form/boomer/types";

export const BoomerFormContext = createContext<ReturnType<typeof useState<AnyBoomerFormApi>>>([
  undefined,
  () => {},
]);

export function BoomerFormContextProvider(props: React.PropsWithChildren) {
  const value = useState<AnyBoomerFormApi>();

  return <BoomerFormContext.Provider value={value} {...props} />;
}

export function useBoomerFormContext() {
  const context = useContext(BoomerFormContext);

  if (!context) {
    throw new Error("useBoomerFormContext must be used within a BoomerFormContextProvider");
  }

  // Explicitly cast to AnyBoomerFormApi to allow for direct usage without any `undefined` types
  return context[0] || ([{}, {}] as unknown as AnyBoomerFormApi);
}
